const uniq = values => [...new Set(values.filter(Boolean))]

export const normalizePrescription = order => {
	const items = Array.isArray(order.procedimientos)
		? order.procedimientos
		: Array.isArray(order.items)
			? order.items
			: []
	return {
		id: order.nroPedido || order.nroAtencion || '',
		fecha: order.fechaEmision || '',
		orden: order.nroPedido || '',
		clinica: uniq(items.map(item => item.clinica)).join(', '),
		especialidad: uniq(items.map(item => item.especialidad)).join(', '),
		profesional: order.nombreProfesional || '',
		procedimientos: uniq(items.map(item => item.procedimiento)).join(', '),
		informacionAdicional: uniq(items.map(item => item.indicacionMedica)),
		telefono: order.telefonoCelular || order.telefono || '',
		estadoPedido: uniq(items.map(item => item.estadoPedido)).join(', '),
		estadoPrescripcion: uniq(items.map(item => item.estadoPrescripcion)).join(', '),
		estadoFinal: uniq(items.map(item => item.estadoFinal)).join(', ')
	}
}

export const normalizePrescriptionsList = list =>
	Array.isArray(list) ? list.map(normalizePrescription) : []
